<template>
  <b-modal v-model="isModalActive" :id="'sideBar'+$store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h1>EDIT ABOUT US</h1>
      </div>

      <div class="form-modal-body">
        <div class="row">
          <VueEditor v-model="form.aboutUs"></VueEditor>
        </div>
      </div>

      <div class="form-modal-footer">
        <b-button :loading="submit_loading" @click="submitForm()" type="is-primary">
          SUBMIT
        </b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { VueEditor } from "vue2-editor";
export default {
  components: {VueEditor},
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    isModalActive: true,
    form: {
      aboutUs: ''
    },
    submit_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.setFormFields();
    } else {
      vm.resetFormFields();
    }
  },
  beforeDestroy() {
    let vm = this;
  },
  methods: {
    setFormFields() {
      let vm = this;
      vm.form.aboutUs = vm.value
    },
    resetFormFields() {
      let vm = this;
      vm.form = {
        aboutUs: ''
      }
    },
    submitForm() {
      let vm = this;
      // Start validate
      const rules = {
        aboutUs: {
          run: (value) => {
            if (!value) {
              return "About Us Text is required";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_loading = true;
        if (vm.$isFieldsValidated(vm.form, rules)) {
          vm.submit_loading = true;
          let obj = {
            aboutUs: vm.form.aboutUs,
          }
          
          vm.$store
            .dispatch("STATIC_UDPATE", obj)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("success", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        }
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;
  transition: .6s;
  @media (max-width: 660px) { 
    width: 90%;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;
    .row {
      .quillWrapper {
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        height: fit-content;
      }
    }
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}
#sideBartrue { 
  left: 230px; 
  @media (max-width: 768px) { 
    left: 0; 
  } 
  .form-modal-widget  { 
    @media (max-width: 846px) { 
      width: 500px; 
    } 
    @media (max-width: 768px) { 
      width: 600px; 
    } 
  } 
} 
</style>
    